<template>
  <div>
    <div class="card card-body p-0" style="border-radius: 10px">
      <requests-table :requests="requests" :totalPages="totalPages" :page="page" @setPage="setPage"></requests-table>
    </div>
  </div>
</template>
<script>
  import helpers from "@/helpers.js";
  import requestsTable from "./requests_table";

  export default {
    components: {
      requestsTable,
    },

    data: function () {
      return {
        page: 0,
      };
    },

    computed: {
      requests: function () {
        return this.$store.getters["support-requests/requests"];
      },
      totalPages: function () {
        return this.$store.getters["support-requests/totalPages"];
      },
    },

    created: function () {
      this.page = helpers.getPageQuery();
    },

    watch: {
      page: function (val) {
        let loader = this.$loading.show({
          loader: "dots",
          container: this.fullPage ? null : this.$refs.formContainer,
        });
        this.$store.dispatch("support-requests/getAllRequests", val);
        setTimeout(() => {
          loader.hide();
        }, 2000);
      },
    },

    methods: {
      setPage(page) {
        this.page = page;
        this.$router.push("support-requests?page=" + page);
      },
    },
  };
</script>